export default "__VITE_ASSET__BnX1crbw__"